import { useRef } from 'react'

import { shallowEqual } from './shallowEqual'

export function useMemoizedObject<T>(obj: T): T {
  const ref = useRef(obj)

  if (!shallowEqual(ref.current, obj)) {
    ref.current = obj
  }

  return ref.current
}
